import { Input } from "@components/Input";
import { PlaceList } from "@components/PlaceList";
import React from "react";

export class PlaceInputList extends React.Component {
  state = {
    sessionToken: null,
    addressString: null,
    addressOptions: [],
    lastScheduledSearch: null,
    searching: false,
  };

  async setStateAsync(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  async searchStringAddress(text) {
    const { countrySlug, stateSlug, citySlug } = this.props;

    const addrString = (text || this.state.addressString || "").trim();

    await this.setStateAsync({ addressOptions: [] });
    if (this.lastScheduledSearch) {
      clearInterval(this.lastScheduledSearch);
      await this.setStateAsync({ lastScheduledSearch: null });
    }

    if (addrString.length < 3) {
      await this.setStateAsync({ searching: false });
      return;
    }

    await this.setStateAsync({ searching: true });

    const lastScheduledSearch = setTimeout(() => {
      const addressOptions = [];

      if (countrySlug && stateSlug && citySlug) {
        const results = PlaceList.getNeighborhoods(
          countrySlug,
          stateSlug,
          citySlug,
          addrString
        );
        addressOptions.push(
          ...results.map(({ neighborhood, slug }) => ({
            title: neighborhood,
            data: slug,
          }))
        );
      } else if (countrySlug && stateSlug) {
        const results = PlaceList.getCities(countrySlug, stateSlug, addrString);
        addressOptions.push(
          ...results.map(({ city, slug }) => ({ title: city, data: slug }))
        );
      } else if (countrySlug) {
        const results = PlaceList.getStates(countrySlug, addrString);
        addressOptions.push(
          ...results.map(({ state, slug }) => ({ title: state, data: slug }))
        );
      }

      this.setStateAsync({
        addressOptions,
        searching: false,
      });
    }, 1000);

    await this.setStateAsync({ lastScheduledSearch });
  }

  onRegionSelected(option, optionIndex, changeInput = true) {
    const { onSelectedRegion } = this.props;

    this.setState({
      addressOptions: [],
      addressString: "",
    });

    if (!option.data) {
      return;
    }

    onSelectedRegion && onSelectedRegion(option);
  }

  render() {
    const { placeholder, search, design, valid, records, recordsText } =
      this.props;

    return (
      <Input
        value={this.state.addressString}
        label={!placeholder && ""}
        placeholder={placeholder}
        options={this.state.addressOptions}
        optload={this.state.searching}
        design={design}
        search={search}
        valid={valid}
        records={records}
        recordsText={recordsText}
        onChange={(text) => {
          this.setState({ addressString: text });
          this.searchStringAddress(text);
        }}
        onOptionSelected={this.onRegionSelected.bind(this)}
      />
    );
  }
}
